import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button, Divider } from 'antd';
import newsData from '../data/news.json';
import '../css/News.css';

const NewsDetailPage = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const isEnglish = location.pathname.startsWith('/en');

    const newsItem = newsData.find(
        item => item.slug === slug || item.id === parseInt(slug, 10)
    );

    if (!newsItem) return <div className="content-ch">找不到此消息</div>;

    const publishedDate = newsItem.date.replace(/\./g, '-');
    const siteUrl = 'https://www.tangwell.com.tw';
    const detailUrl = isEnglish ? `${siteUrl}/en/news/${newsItem.slug}` : `${siteUrl}/news/${newsItem.slug}`;

    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'NewsArticle',
        mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': detailUrl
        },
        headline: newsItem.titleCh,
        description: newsItem.contentCh.slice(0, 120),
        image: newsItem.gallery?.map(img => `${siteUrl}/images/NewsPage/${img}`) || [],
        datePublished: publishedDate,
        author: {
            '@type': 'Organization',
            name: '湯武生技'
        },
        publisher: {
            '@type': 'Organization',
            name: '湯武生技',
            logo: {
                '@type': 'ImageObject',
                url: `${siteUrl}/logo.png`
            }
        }
    };

    return (
        <div className="news-page">
            <Helmet>
                <title>{isEnglish ? newsItem.titleEn : `湯武生技 - ${newsItem.titleCh}`}</title>
                <meta name="description" content={isEnglish ? newsItem.contentEn.slice(0, 74) : newsItem.contentCh.slice(0, 74)} />
                <meta name="keywords" content={isEnglish ? "Tang Wu, news, announcements" : "湯武生技, 最新消息, 食品安全, 餐飲原料"} />
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            </Helmet>
            <div className="news-detail-banner">
                <div className="banner-content">
                    {isEnglish ? (
                        <>
                            <div className="big-title-en">{newsItem.titleEn}</div>
                        </>
                    ) : (
                        <>
                            <div className="title-en">{newsItem.titleEn}</div>
                            <div className="big-title-ch">{newsItem.titleCh}</div>
                        </>
                    )}
                </div>
            </div>

            <div className="news-container container-narrow">
                <div className="news-card-detail">
                    <div className="news-tag">{isEnglish ? newsItem.categoryEn : newsItem.categoryCh}</div>

                    <div className="news-content">
                        <div className="content-ch mb-20">{newsItem.contentCh}</div>
                        <div className="content-en">{newsItem.contentEn}</div>
                    </div>

                    {/* 多圖展示區 */}
                    {newsItem.gallery && newsItem.gallery.length > 0 && (
                        <div className="news-detail-image-box">
                            {newsItem.gallery.map((img, index) => (
                                <img
                                    key={index}
                                    src={require(`../images/NewsPage/${img}`)}
                                    alt={`${newsItem.titleCh} 圖片 ${index + 1}`}
                                    className="detail-block-img"
                                    loading="lazy"
                                />
                            ))}
                        </div>
                    )}

                    {newsItem.links && (
                        <div className="news-external-links">
                            <Divider orientation="left" className="content-ch divider-text">相關連結</Divider>
                            <Divider orientation="left" className="content-en divider-text">Related Links</Divider>
                            <ol className="news-links-ol">
                                {newsItem.links.map((link, index) => (
                                    <li key={index} className="link-item mb-20">
                                        <div className="content-ch mb-5">
                                            {link.label}
                                            <a
                                                href={link.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="content-en link-url"
                                            >
                                                {link.url}
                                            </a>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </div>
                    )}

                    <div className="news-date content-en mt-20 mb-20">{newsItem.date}</div>

                    <div className='news-btn-wrapper'>
                        <Button className='back-btn' onClick={() => navigate(isEnglish ? '/en/news' : '/news')}>
                            {isEnglish ? 'Back' : '上一頁'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsDetailPage;